import React from 'react';
import Logo from '../assets/Images/Logo.png';

const Navbar = ({ minimal = false }) => {
  const handleLogoClick = () => {
    window.location.href = "https://www.pongoinc.com";
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-[var(--bg-black)] p-4 ${
        minimal ? '' : 'bg-[var(--bg-black)]'
      }`}
    >
      <div className="max-w-7xl mx-auto w-full">
        <div
          className="flex items-center cursor-pointer"
          onClick={handleLogoClick}
          aria-label="Go to Pongo homepage"
        >
          <img
            src={Logo}
            alt="Pongo logo"
            className="h-8 w-8 md:h-10 md:w-10"
          />
          {minimal ? (
            <span className="ml-2 text-xl font-bold bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-pink-500">
              Pongo
            </span>
          ) : (
            <span className="ml-2 text-xl font-bold text-pink-500 md:text-2xl">
              Pongo
            </span>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;